import React, { Suspense } from 'react'
import { useSelector } from 'react-redux'
import { Navigate, Route, Routes } from 'react-router-dom'

// components
import { CContainer, CSpinner } from '@coreui/react-pro'
import AppLoader from './AppLoader'

// styling
import { styleContainerVars1 } from './custom-styles/containerStyle'

// routes config
import routes from '../routes'

const AppContent = () => {
  const isLoading = useSelector((state) => state.isLoading)

  return (
    <CContainer style={styleContainerVars1}>
      <Suspense fallback={<CSpinner color='primary' />}>
          {
            isLoading && (
              <AppLoader/>
            )
          }
        <Routes>
          {routes.map((route, idx) => {
            return (
              route.element && (
                <Route
                  key={idx}
                  path={route.path}
                  exact={route.exact}
                  name={route.name}
                  element={<route.element />}
                />
              )
            )
          })}
          <Route path='/' element={<Navigate to='dashboard' replace />} />
        </Routes>
      </Suspense>
    </CContainer>
  )
}

export default AppContent
